import React from 'react';
import dayjs from 'dayjs';

import { addConnectedInvoice, createOrJoinNotConnectedConsumptionInvoices, setInvoiceStornoPreview } from './controler';
import numbro from 'numbro';
import { CheckoutOptionsProps } from './interfaces';
//@ts-ignore
import { Link } from 'react-router-dom';
import { InvoiceModelWithInvoiceItems } from '@common/modelDefinition';

import { RemoveInvoiceMenu, StornoInvoiceMenu } from './CheckoutOptions';
import PermissionCheck from '@components/PermissionCheck';

export enum InvoiceTypeEnum {
    geniue,
    advance,
    proforma,
    proformaDispatched,
}

const IssuedInvoicesList = (props: CheckoutOptionsProps) => {
    const {
        // advanceInvoices,
        proformaInvoices,
        // stornoInvoices,
        posTerminalInvoices = [],
        minibarInvoices = [],
        translate,
    } = props;
    // const [expanded, setExpanded] = React.useState(true);
    const filteredPosTerminalInvoices = posTerminalInvoices.filter((i) => {
        const { InvoiceItems } = i;
        const accommodationInvoiceItems = InvoiceItems ? InvoiceItems.filter((it) => it.type === 'accommodation') : [];
        if (
            accommodationInvoiceItems.length === 0 &&
            i.reclamation === 0 &&
            !i.connectedInvoiceProcessed &&
            i.invoiceType === InvoiceTypeEnum.proformaDispatched
        ) {
            return i;
        } else {
            return null;
        }
    });

    const filteredProformaFromCheckoutPosInvoices = posTerminalInvoices.filter((i) => {
        const { InvoiceItems } = i;
        const accommodationInvoiceItems = InvoiceItems ? InvoiceItems.filter((it) => it.type === 'accommodation') : [];
        if (
            accommodationInvoiceItems.length === 0 &&
            i.reclamation === 0 &&
            !i.connectedInvoiceProcessed &&
            i.invoiceType === InvoiceTypeEnum.proforma
        ) {
            return i;
        } else {
            return null;
        }
    });

    const filteredProformaInvoices = proformaInvoices
        .filter((i) => {
            const { InvoiceItems } = i;
            const accommodationInvoiceItems = InvoiceItems
                ? InvoiceItems.filter((it) => it.type === 'accommodation')
                : [];
            if (accommodationInvoiceItems.length === 0 && i.reclamation === 0 && !i.connectedInvoiceProcessed) {
                return i;
            } else {
                return null;
            }
        })
        .concat(filteredProformaFromCheckoutPosInvoices);

    const filteredMinibarInvoices = minibarInvoices.filter((i) => i.reclamation === 0 && !i.connectedInvoiceProcessed);
    // const unfoldCount: number =
    //     advanceInvoices.length +
    //     filteredProformaInvoices.length +
    //     stornoInvoices.length +
    //     filteredPosTerminalInvoices.length +
    //     filteredMinibarInvoices.length;
    return (
        <div className="">
            {/* {unfoldCount > 0 ? (
                <div
                    className="pointer unselectable"
                    onClick={() => {
                        setExpanded(!expanded);
                    }}
                >
                     <div className="mb-2p">
                        <b>{translate('Related invoices')} ({unfoldCount})</b>
                    </div>
                    {!expanded && (
                        <small>
                            <small>{translate('click to expand')}</small>
                        </small>
                    )}
                </div>
            ) : null} */}
            {/* {expanded && ( */}
            <div>
                <GenuineInvoiceList {...props} />
                <AdvanceInvoiceList {...props} />
                {/* <ProformaInvoiceList {...props} /> */}

                {filteredProformaInvoices.length > 0 ? (
                    <div className="">
                        <div className="mt-16p">
                            <b>{translate('Proforma invoices')}</b>
                        </div>
                        <ConsumptionInvoiceList
                            keyName="proforma"
                            consumptionInvoices={filteredProformaInvoices}
                            {...props}
                        />
                    </div>
                ) : null}

                {filteredPosTerminalInvoices.length > 0 ? (
                    <div className="">
                        <div className="mt-16p font-14p">{translate('POS terminal invoices')}</div>
                        <ConsumptionInvoiceList
                            keyName="posDispatched"
                            consumptionInvoices={filteredPosTerminalInvoices}
                            {...props}
                        />
                    </div>
                ) : null}
                {filteredMinibarInvoices.length > 0 ? (
                    <div className="">
                        <div className="mt-16p font-14p">{translate('Minibar invoices')}</div>
                        <ConsumptionInvoiceList
                            keyName="minibar"
                            consumptionInvoices={filteredMinibarInvoices}
                            {...props}
                        />
                    </div>
                ) : null}
                <StornoInvoiceList {...props} />
            </div>
            {/* )} */}
        </div>
    );
};

//ne smiješ dozvoliti storniranje avansnih računa ako je račun izdan i zaključen
const AdvanceInvoiceList = (props: CheckoutOptionsProps) => {
    const { advanceInvoices = [], invoice: activeInvoice, translate, genuineInvoices } = props;
    const [showMoreOptions, setShowMoreOptions] = React.useState<number | null>(null);

    if (advanceInvoices.length === 0) {
        return null;
    }

    return (
        <div className="mt-16p">
            <div className="mb-4p font-14p">{translate('Advance invoices')}</div>
            {advanceInvoices &&
                advanceInvoices.map((i: InvoiceModelWithInvoiceItems, index) => {
                    const targetInvoiceIssued: InvoiceModelWithInvoiceItems[] = genuineInvoices.filter(
                        (g: InvoiceModelWithInvoiceItems) => {
                            if (g.terminalType === 'reservation' && i.terminalType === 'reservation') {
                                return g;
                            } else if (g.terminalType === 'reservationConsumption') {
                                const { connectedInvoices } = g;
                                if (
                                    connectedInvoices &&
                                    connectedInvoices.length > 0 &&
                                    i.connectedInvoices &&
                                    i.connectedInvoices.length > 0 &&
                                    connectedInvoices.includes(i.connectedInvoices[0])
                                ) {
                                    return g;
                                } else {
                                    return null;
                                }
                            } else {
                                return null;
                            }
                        }
                    );
                    return (
                        <div id="" key={index} className="invoice-item disabled mb-2p">
                            <div className="display-flex align-items-center">
                                <div>
                                    <input
                                        disabled={true}
                                        checked={false}
                                        onChange={async () => {
                                            return null;
                                        }}
                                        className="checkbox-primary"
                                        type="checkbox"
                                    ></input>
                                </div>
                                <div className="ml-16p text-bold">
                                    <Link
                                        key={index}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        to={'/invoiceView/' + i.id + '?noActions'}
                                    >
                                        #
                                        {i.invoiceNumberFull?.split('/').map((tekst, index) => {
                                            if (index === 0) {
                                                return tekst;
                                            } else {
                                                return null;
                                            }
                                        })}
                                    </Link>
                                </div>
                            </div>
                            <div className="display-flex align-items-center">
                                <div className="mr-30p">
                                    {i.timestamp ? dayjs(i.timestamp).format('LL') : 'unknown'}
                                </div>

                                {/* <div className="">
                                    {activeInvoice.pendingInvoice && targetInvoiceIssued.length === 0 ? (
                                        <StornoButton {...props} invoiceForStorno={i} />
                                    ) : null}
                                </div> */}
                                <div className="mr-16p">
                                    {numbro(Number(i.totalValue) * Number(i.currencyExchangeRate)).format({
                                        mantissa: 2,
                                        trimMantissa: false,
                                        thousandSeparated: true,
                                    })}{' '}
                                    {i.currency}
                                </div>
                                {activeInvoice.pendingInvoice && targetInvoiceIssued.length === 0 ? (
                                    <StornoInvoiceMenu
                                        setShowMoreOptions={setShowMoreOptions}
                                        showMoreOptions={showMoreOptions}
                                        invoice={i}
                                        keyName={'advance'}
                                        index={index}
                                    />
                                ) : (
                                    <div className="pr-16p pl-16p pb-16p pt-16p"></div>
                                )}
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};

// const ProformaInvoiceList = (props: CheckoutOptionsProps) => {
//     const { proformaInvoices = [], invoice: activeInvoice, translate } = props;

//     if (proformaInvoices.length === 0) {
//         return null;
//     }
//     return (
//         <ul className="list-group mt-2">
//             <li className="list-group-item p-1 text-center">
//                 <b>{translate('Proforma invoices')}</b>
//             </li>
//             {proformaInvoices &&
//                 proformaInvoices.map((i, index) => {
//                     return (
//                         <li key={index} className="list-group-item p-2">
//                             <div className="row">
//                                 <div className="col-2">
//                                     <Link
//                                         key={index}
//                                         target="_blank"
//                                         rel="noopener noreferrer"
//                                         to={'/invoiceView/' + i.id + '?noActions'}
//                                     >
//                                         {i.invoiceNumberFull?.split('/').map((tekst, index) => {
//                                             if (index === 0) {
//                                                 return tekst;
//                                             }
//                                         })}
//                                     </Link>
//                                 </div>
//                                 <div className="col-3">
//                                     {i.timestamp ? dayjs(i.timestamp).format('LL') : 'unknown'}
//                                 </div>
//                                 <div className="col-4">
//                                     {activeInvoice.pendingInvoice ? (
//                                         <StornoButton invoiceForStorno={i} {...props} />
//                                     ) : null}
//                                 </div>
//                                 <div className="col-3 text-right">
//                                     {numbro(Number(i.totalValue) * Number(i.currencyExchangeRate)).format({
//                                         mantissa: 2,
//                                         trimMantissa: false,
//                                         thousandSeparated: true,
//                                     })}{' '}
//                                     {i.currency}
//                                 </div>
//                             </div>
//                         </li>
//                     );
//                 })}
//         </ul>
//     );
// };

interface ConsumptionListProps extends CheckoutOptionsProps {
    consumptionInvoices: InvoiceModelWithInvoiceItems[];
    keyName: string;
}

export const ConsumptionInvoiceList = (props: ConsumptionListProps) => {
    const {
        invoice: activeInvoice,
        groupReservationsArray,
        consumptionInvoices,
        reservationId,
        groupUuid,
        advanceInvoices,
        keyName,
        invoiceStornoPreview,
    } = props;
    const [showMoreOptions, setShowMoreOptions] = React.useState<number | null>(null);

    if (consumptionInvoices.length === 0) {
        return null;
    }

    const { terminalType, invoiceType } = activeInvoice;
    return (
        <div>
            {consumptionInvoices.map((i: InvoiceModelWithInvoiceItems, index: number) => {
                const reservation = i.groupUuid ? groupReservationsArray.find((r) => r.id === i.reservationId) : null;
                const roomName: string | undefined = reservation?.RoomInfo?.name;
                const addOrRemoveFromConnectedInvoices: boolean =
                    i.id && activeInvoice.connectedInvoices && activeInvoice.connectedInvoices.includes(i.id)
                        ? false
                        : true; //false = add, true = remove
                const disableRemoveInvoice: boolean =
                    activeInvoice && i && i.id && activeInvoice.connectedInvoices.includes(i.id) ? true : false;

                const disableDeleteProforma = advanceInvoices.filter((a) => {
                    if (
                        a.connectedInvoices &&
                        a.connectedInvoices.length > 0 &&
                        Number(a.connectedInvoices[0]) === Number(i.id)
                    ) {
                        return a;
                    } else {
                        return null;
                    }
                });

                const disableWhenAdvanceIssued =
                    invoiceType === InvoiceTypeEnum.advance ||
                    (disableDeleteProforma.length > 0 && invoiceType === InvoiceTypeEnum.proforma);

                return (
                    <div
                        key={keyName + index}
                        className={
                            !invoiceStornoPreview
                                ? addOrRemoveFromConnectedInvoices && i.connectedInvoiceProcessed !== 1
                                    ? 'invoice-item pointer'
                                    : 'invoice-item-selected pointer'
                                : 'invoice-item pointer'
                        }
                        onClick={async () => {
                            if (addOrRemoveFromConnectedInvoices) {
                                if (
                                    i.connectedInvoiceProcessed !== 1 &&
                                    addOrRemoveFromConnectedInvoices &&
                                    terminalType === 'reservation' &&
                                    activeInvoice.id === undefined
                                ) {
                                    if (!invoiceStornoPreview) {
                                        await createOrJoinNotConnectedConsumptionInvoices(i, reservationId, groupUuid);
                                    }
                                } else {
                                    if (
                                        invoiceStornoPreview ||
                                        i.connectedInvoiceProcessed === 1 ||
                                        !activeInvoice.pendingInvoice ||
                                        (addOrRemoveFromConnectedInvoices && disableWhenAdvanceIssued) ||
                                        (disableDeleteProforma.length > 0 && addOrRemoveFromConnectedInvoices)
                                    ) {
                                        return null;
                                    } else {
                                        if (i.id && !invoiceStornoPreview) {
                                            addConnectedInvoice(i.id, reservationId, groupUuid);
                                        }
                                    }
                                }
                            } else {
                                //Remove
                                if (i.id && !invoiceStornoPreview) {
                                    addConnectedInvoice(i.id, reservationId, groupUuid);
                                }
                            }
                        }}
                    >
                        <div className="display-flex align-items-center">
                            {addOrRemoveFromConnectedInvoices ? (
                                <React.Fragment>
                                    <input
                                        disabled={
                                            invoiceStornoPreview
                                                ? true
                                                : addOrRemoveFromConnectedInvoices &&
                                                  (i.connectedInvoiceProcessed === 1 ||
                                                      !activeInvoice.pendingInvoice ||
                                                      (addOrRemoveFromConnectedInvoices && disableWhenAdvanceIssued) ||
                                                      (disableDeleteProforma.length > 0 &&
                                                          addOrRemoveFromConnectedInvoices))
                                                ? i.connectedInvoiceProcessed !== 1 &&
                                                  addOrRemoveFromConnectedInvoices &&
                                                  terminalType === 'reservation' &&
                                                  activeInvoice.id === undefined
                                                    ? false
                                                    : true
                                                : false
                                        }
                                        checked={false}
                                        onChange={async () => {
                                            return null;
                                        }}
                                        className="checkbox-primary"
                                        type="checkbox"
                                    ></input>
                                </React.Fragment>
                            ) : (
                                <input
                                    disabled={invoiceStornoPreview ? true : false}
                                    checked={invoiceStornoPreview ? false : true}
                                    onChange={async () => {
                                        // remove
                                        return null;
                                    }}
                                    className="checkbox-primary"
                                    type="checkbox"
                                ></input>
                            )}

                            <div className="ml-16p text-bold">
                                <Link
                                    key={index}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    to={'/invoiceView/' + i.id + '?noActions'}
                                >
                                    #
                                    {roomName
                                        ? i.invoiceNumberFull?.split('/').map((tekst, index) => {
                                              if (index === 0) {
                                                  return `${tekst} (${roomName})`;
                                              } else {
                                                  return null;
                                              }
                                          })
                                        : i.invoiceNumberFull?.split('/').map((tekst, index) => {
                                              if (index === 0) {
                                                  return tekst;
                                              } else {
                                                  return null;
                                              }
                                          })}
                                </Link>
                            </div>
                        </div>
                        <div className="display-flex align-items-center">
                            <div className="mr-30p text-left">
                                {i.timestamp ? dayjs(i.timestamp).format('LL') : 'unknown'}
                            </div>
                            <div className="mr-16p">
                                {numbro(Number(i.totalValue) * Number(i.currencyExchangeRate)).format({
                                    mantissa: 2,
                                    trimMantissa: false,
                                    thousandSeparated: true,
                                })}{' '}
                                {i.currency}
                            </div>
                            <div>
                                {disableDeleteProforma.length === 0 &&
                                !disableWhenAdvanceIssued &&
                                !disableRemoveInvoice ? (
                                <PermissionCheck name="invoice_removeInvoice">
                                    <RemoveInvoiceMenu
                                        setShowMoreOptions={setShowMoreOptions}
                                        showMoreOptions={showMoreOptions}
                                        invoice={i}
                                        keyName={keyName}
                                        index={index}
                                        reservationId={reservationId}
                                        groupUuid={groupUuid}
                                    />
                                </PermissionCheck>
                                ) : (
                                    <div className="pr-16p pl-16p pb-16p pt-16p"></div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export const StornoButton = (props: CheckoutOptionsProps) => {
    const { invoiceForStorno, translate, invoiceStornoPreview, invoice } = props;
    if (!invoiceForStorno || invoiceStornoPreview || invoice.id) {
        return null;
    }

    return (
        <button
            onClick={() => {
                setInvoiceStornoPreview(invoiceForStorno);
            }}
            className="button-white-only"
        >
            {translate('STORNO')}
        </button>
    );
};
const StornoInvoiceList = (props: CheckoutOptionsProps) => {
    const { stornoInvoices, translate } = props;

    if (stornoInvoices.length === 0) {
        return null;
    }

    return (
        <div className="">
            <div className="mt-16p">
                <b>{translate('Storno invoices')}</b>
            </div>
            {stornoInvoices.map((i, index) => {
                return (
                    <div id="" key={index} className="invoice-item disabled mb-2p">
                        <div className="display-flex align-items-center">
                            <div>
                                <input
                                    disabled={true}
                                    checked={false}
                                    onChange={() => {
                                        return null;
                                    }}
                                    className="checkbox-primary"
                                    type="checkbox"
                                ></input>
                            </div>
                            <div className="ml-16p text-bold">
                                <Link
                                    key={index}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    to={'/invoiceView/' + i.id + '?noActions'}
                                >
                                    #
                                    {i.invoiceNumberFull?.split('/').map((tekst, index) => {
                                        if (index === 0) {
                                            return tekst;
                                        } else {
                                            return null;
                                        }
                                    })}
                                </Link>
                            </div>
                        </div>
                        <div className="display-flex align-items-center">
                            <div className="mr-30p">{i.timestamp ? dayjs(i.timestamp).format('LL') : 'unknown'}</div>
                            {/* <div className="">
                                {i.invoiceType === InvoiceTypeEnum.geniue && translate('(invoice)')}
                                {i.invoiceType === InvoiceTypeEnum.advance && translate('(advance)')}
                                {i.invoiceType === InvoiceTypeEnum.proforma && translate('(proforma)')}
                            </div> */}
                            <div className="mr-16p">
                                {numbro(Number(i.totalValue) * Number(i.currencyExchangeRate)).format({
                                    mantissa: 2,
                                    trimMantissa: false,
                                    thousandSeparated: true,
                                })}{' '}
                                {i.currency}
                            </div>
                            <div className="pr-16p pl-16p pb-16p pt-16p"></div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

const GenuineInvoiceList = (props: CheckoutOptionsProps) => {
    const { genuineInvoices, translate } = props;
    const [showMoreOptions, setShowMoreOptions] = React.useState<number | null>(null);

    if (genuineInvoices.length === 0) {
        return null;
    }

    const filteredGenuineInvoices = genuineInvoices.filter((i) => {
        const { InvoiceItems } = i;
        const accommodationInvoiceItems = InvoiceItems.filter((it) => it.type === 'accommodation');
        if (accommodationInvoiceItems.length === 0) {
            return i;
        } else {
            return null;
        }
    });
    return (
        <div className="">
            {filteredGenuineInvoices.length > 0 ? (
                <div className="mb-4p font-14p">{translate('Genuine invoices')}</div>
            ) : null}
            {filteredGenuineInvoices &&
                filteredGenuineInvoices.map((i, index) => {
                    return (
                        <div id="" key={index} className="invoice-item disabled mb-2p">
                            <div className="display-flex align-items-center">
                                <div>
                                    <input
                                        disabled={true}
                                        checked={false}
                                        onChange={() => {
                                            return null;
                                        }}
                                        className="checkbox-primary"
                                        type="checkbox"
                                    ></input>
                                </div>
                                <div className="ml-16p text-bold">
                                    <Link
                                        key={index}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        to={'/invoiceView/' + i.id + '?noActions'}
                                    >
                                        #
                                        {i.invoiceNumberFull?.split('/').map((tekst, index) => {
                                            if (index === 0) {
                                                return tekst;
                                            } else {
                                                return null;
                                            }
                                        })}
                                    </Link>
                                </div>
                            </div>
                            <div className="display-flex align-items-center">
                                <div className="mr-30p">
                                    {i.timestamp ? dayjs(i.timestamp).format('LL') : 'unknown'}
                                </div>
                                <div className="mr-16p">
                                    {numbro(Number(i.totalValue) * Number(i.currencyExchangeRate)).format({
                                        mantissa: 2,
                                        trimMantissa: false,
                                        thousandSeparated: true,
                                    })}{' '}
                                    {i.currency}
                                </div>
                                <StornoInvoiceMenu
                                    setShowMoreOptions={setShowMoreOptions}
                                    showMoreOptions={showMoreOptions}
                                    invoice={i}
                                    keyName={'genuine'}
                                    index={index}
                                />
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};

export default IssuedInvoicesList;
